module.exports = __webpack_public_path__ + "img/vicky_headshot.37e0d502.jpg";